<template>
  <div class="page px-5">
    <page-layout>
      <h3
        slot="header"
        class="my-4 text-truncate"
      >
        <span class="d-none d-lg-inline">Manage</span>&nbsp;Api Resources
      </h3>
      <b-button
        slot="header"
        size="sm"
        variant="primary"
        @click="addApiResource()"
      >
        <i class="fa fa-plus" />
        <span class="d-none d-lg-inline-block">&nbsp; ADD API RESOURCE</span>
      </b-button>
      <api-resource-list />
    </page-layout>
  </div>
</template>

<script>
import PageLayout from "@/components/shared/PageLayout.vue";
import ApiResourceList from "@/components/apiResources/ApiResourceList.vue";

export default {
  components: {
    PageLayout,
    ApiResourceList
  },
  methods: {
    addApiResource() {
      this.$router.push({ path: `/apiResources/new` });
    }
  }
};
</script>
